import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import OAuthButtons from '../components/OAuthButtons';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      await register({ email, password, name });
      navigate('/dashboard');
    } catch (err) {
      setError(err?.response?.data?.message || 'Registration failed');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <Link to="/" style={{ display: 'block', textAlign: 'center', marginBottom: 32, textDecoration: 'none' }}>
          <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.5px' }}>dApiary</span>
        </Link>

        <div className="card" style={{ padding: 32 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 6, textAlign: 'center' }}>Create account</h1>
          <p style={{ textAlign: 'center', color: 'var(--text-3)', fontSize: 13, marginBottom: 24 }}>
            Buy and sell ML datasets & models
          </p>

          <OAuthButtons onError={setError} />

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {[['Name', 'text', name, setName], ['Email address', 'email', email, setEmail]].map(([l, t, v, s]) => (
              <div key={l}>
                <label style={lbl}>{l}</label>
                <input type={t} value={v} onChange={e => s(e.target.value)} required className="field" style={{ width: '100%', boxSizing: 'border-box' }} />
              </div>
            ))}
            <div>
              <label style={lbl}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="field" style={{ width: '100%', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={lbl}>Confirm password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required className="field" style={{ width: '100%', boxSizing: 'border-box' }} />
            </div>

            {error && (
              <div style={{ padding: '10px 13px', borderRadius: 'var(--radius-sm)', background: 'var(--danger-bg)', color: 'var(--danger)', fontSize: 13, border: '1px solid #FECACA' }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%', padding: 11, marginTop: 4 }}>
              {loading ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-2)' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: 'var(--accent)', textDecoration: 'none', fontWeight: 500 }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: 'var(--text-2)', marginBottom: 6 };
